<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Terms"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
        {
          text: 'Configuración y politicas',
          disabled: false,
          href: '/admin/terms'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: $route.params.id ? 'Editar' : 'Crear',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider
                ref="type"
                rules="required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Tipo</div>
                <v-select
                  :error-messages="errors"
                  v-model="data.type"
                  label="Tipo"
                  :items="types"
                   solo
                    hide-details="auto"
                    class="input-base"
                    append-icon="$caretDownFormIcon"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col>
              <ValidationProvider
                ref="description"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Descripción</div>
                <v-textarea
                  :error-messages="errors"
                  v-model="data.description"
                  solo
                  placeholder="Descripción"
                  hide-details="auto"
                  class="text-tarea-base legal-text-area-scroll"
                  :rows="dynamicRows"
                />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  mounted() {
    this.calculateRows();
    window.addEventListener("resize", this.calculateRows);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateRows);
  },
  data() {
    return {
      storeName: "Terms",
      title: "Terminos y Condiciones",
      types: ["Owner", "Driver"],
      data: {
        title: "",
        type: "",
        description: "",
      },
      dynamicRows: 6,
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Terms.status,
    }),
  },
  watch: {},
  methods: {
    calculateRows() {
      const viewportHeight = window.innerHeight;

      const rowHeight = 24;
      const usedHeight = viewportHeight * 0.4;

      const rows = Math.max(3, Math.min(Math.floor(usedHeight / rowHeight), 30));

      this.dynamicRows = rows;
    },
  },
};
</script>